import { Grid, Skeleton, Typography } from "@mui/material";
import { fieldHeader } from "../../../../../components/fields/field_header";

const ViewCorporationInformationSkeleton = () => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          CORPORATION INFORMATION:
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid item>{fieldHeader("Legal Corporate Name", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>

      <Grid item xs={12}>
        <Grid item>
          {fieldHeader(
            "Corporation Address (if different from store address)",
            false
          )}
        </Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>

      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Corporation City", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>

      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Corporation State", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>

      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Corporation ZIP", false)}</Grid>
        <Skeleton variant="text" width="100%" />
      </Grid>
    </>
  );
};

export default ViewCorporationInformationSkeleton;
